/**
 * 策划中心-实时线索-左侧导航
 * 2017-11-10 
 * Bai.Zhiming
 */
"use strict";
angular.module("realTimeCluesLeftModule", []).
directive("realTimeCluesLeft", ["$state", "$timeout", function($state, $timeout) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./planningCenter/realTimeClues/left/left_tpl.html",
        scope: {
            selected: "="
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    expanded: false,
                    expandedLeve2: ""
                };
                autoLocation()
            }

            function autoLocation() {
                scope.$watch("selected", (newV, oldV) => {
                    if (newV === "realtimeclues") {
                        scope.status.expanded = true;
                        let routerName = $state.current.name;
                        let routerArray = routerName.split(".");
                        if ($state.current.name != "front.plan.realtimeclues") {
                            scope.status.expandedLeve2 = routerArray[3];
                            scope.status.selectedLeve3 = routerArray[3] + "." + routerArray[4];
                        }
                    } else {
                        scope.status.expandedLeve2 = "";
                    }
                });
            }
            /**
             * [expandLeve2 description] 展开二级
             * @param  {[type]} type [description] 类型名称
             * @return {[type]}      [description]
             */
            scope.expandLeve2 = function(type, $event) {
                scope.status.expandedLeve2 = type;
                $timeout(() => {
                    $($event.currentTarget).next("ul").find("a")[0].click();
                    scope.$root.narrowNavigation = false;
                });
            };
            /**
             * [selectLeve3 description] 选中三级
             * @param  {[type]} routerNamePart [description] 路由名称
             * @return {[type]}            [description]
             */
            scope.selectLeve3 = function(routerNamePart) {
                let routerName = "front.plan.realtimeclues." + routerNamePart;
                $state.go(routerName, {}, { reload: routerName });
                scope.status.selectedLeve3 = routerNamePart;
                if (scope.selected !== "realtimeclues") {
                    $timeout(()=>{
                        scope.selected = "realtimeclues";
                    },500);
                }
            };
        }
    };
}]);